export const AREA_CODES = ["201",
	"202",
	"203",
	"205",
	"206",
	"207",
	"208",
	"209",
	"210",
	"212",
	"213",
	"214",
	"215",
	"216",
	"217",
	"218",
	"219",
	"220",
	"223",
	"224",
	"225",
	"227",
	"228",
	"229",
	"231",
	"234",
	"239",
	"240",
	"248",
	"251",
	"252",
	"253",
	"254",
	"256",
	"260",
	"262",
	"267",
	"269",
	"270",
	"272",
	"274",
	"276",
	"279",
	"281",
	"283",
	"301",
	"302",
	"303",
	"304",
	"305",
	"307",
	"308",
	"309",
	"310",
	"312",
	"313",
	"314",
	"315",
	"316",
	"317",
	"318",
	"319",
	"320",
	"321",
	"323",
	"325",
	"326",
	"329",
	"330",
	"331",
	"332",
	"334",
	"336",
	"337",
	"339",
	"340",
	"341",
	"346",
	"347",
	"350",
	"351",
	"352",
	"360",
	"361",
	"363",
	"364",
	"369",
	"380",
	"385",
	"386",
	"401",
	"402",
	"404",
	"405",
	"406",
	"407",
	"408",
	"409",
	"410",
	"412",
	"413",
	"414",
	"415",
	"417",
	"419",
	"423",
	"424",
	"425",
	"430",
	"432",
	"434",
	"435",
	"440",
	"442",
	"443",
	"445",
	"447",
	"448",
	"458",
	"463",
	"464",
	"469",
	"470",
	"472",
	"475",
	"478",
	"479",
	"480",
	"484",
	"501",
	"502",
	"503",
	"504",
	"505",
	"507",
	"508",
	"509",
	"510",
	"512",
	"513",
	"515",
	"516",
	"517",
	"518",
	"520",
	"530",
	"531",
	"534",
	"539",
	"540",
	"541",
	"551",
	"557",
	"559",
	"561",
	"562",
	"563",
	"564",
	"567",
	"570",
	"571",
	"572",
	"573",
	"574",
	"575",
	"580",
	"582",
	"585",
	"586",
	"601",
	"602",
	"603",
	"605",
	"606",
	"607",
	"608",
	"609",
	"610",
	"612",
	"614",
	"615",
	"616",
	"617",
	"618",
	"619",
	"620",
	"623",
	"626",
	"628",
	"629",
	"630",
	"631",
	"636",
	"640",
	"641",
	"645",
	"646",
	"650",
	"651",
	"656",
	"657",
	"659",
	"660",
	"661",
	"662",
	"667",
	"669",
	"670",
	"671",
	"678",
	"680",
	"681",
	"682",
	"689",
	"701",
	"702",
	"703",
	"704",
	"706",
	"707",
	"708",
	"712",
	"713",
	"714",
	"715",
	"716",
	"717",
	"718",
	"719",
	"720",
	"724",
	"725",
	"726",
	"727",
	"728",
	"730",
	"731",
	"732",
	"734",
	"737",
	"740",
	"743",
	"747",
	"754",
	"757",
	"760",
	"762",
	"763",
	"765",
	"769",
	"770",
	"771",
	"772",
	"773",
	"774",
	"775",
	"779",
	"781",
	"785",
	"786",
	"787",
	"801",
	"802",
	"803",
	"804",
	"805",
	"806",
	"808",
	"810",
	"812",
	"813",
	"814",
	"815",
	"816",
	"817",
	"818",
	"820",
	"826",
	"828",
	"830",
	"831",
	"832",
	"835",
	"838",
	"839",
	"840",
	"843",
	"845",
	"847",
	"848",
	"850",
	"854",
	"856",
	"857",
	"858",
	"859",
	"860",
	"861",
	"862",
	"863",
	"864",
	"865",
	"870",
	"872",
	"878",
	"901",
	"903",
	"904",
	"906",
	"907",
	"908",
	"909",
	"910",
	"912",
	"913",
	"914",
	"915",
	"916",
	"917",
	"918",
	"919",
	"920",
	"925",
	"928",
	"929",
	"930",
	"931",
	"934",
	"936",
	"937",
	"938",
	"939",
	"940",
	"941",
	"943",
	"945",
	"947",
	"948",
	"949",
	"951",
	"952",
	"954",
	"956",
	"959",
	"970",
	"971",
	"972",
	"973",
	"978",
	"979",
	"980",
	"983",
	"984",
	"985",
	"986",
	"989",
	"867",
	"671",
	"778",
	"587",
	"581",
	"705",
	"519",
	"250",
	"204",
	"807",
	"450",
	"514",
	"438",
	"289",
	"867",
	"416",
	"647",
	"226",
	"780",
	"902",
	"604",
	"403",
	"306",
	"613",
	"819",
	"418",
	"709",
	"506",
	"905",
	"684",
	"670", // last ca
    "738",
    "436",
    "235",
    "353",
    "624",
    "686",
    "975",
    "327",
    "324",
    "236",
    "672",
    "825",
    "368",
    "367",
    "249",
    "683",
    "548",
    "382",
    "431",
    "584",
    "579",
    "354",
    "263",
    "365",
    "742",
    "437",
    "782",
    "639",
    "474",
    "343",
    "753",
    "873",
    "468",
    "879",
    "428",
]

export const REGION_INDEX_TO_AREA_CODE_INDEX = [
    [0], [1], [2], [3], [4], [5], [6], [7], [8], [9], [10, 387], [11], [12], [13], [14], [15], [16], [17], 
    [18], [19], [20], [21], [22], [23], [24], [25], [26], [27], [28], [29], [30], [31], [32], [33], 
    [34], [35], [36], [37], [38], [39], [40], [41], [42], [43], [44], [45], [46], [47], [48], [49], 
    [50], [51], [52], [53], [54], [55], [56], [57], [58], [59], [60], [61], [62], [63], [64, 387], [65], 
    [66], [67], [68], [69], [70], [71], [72], [73], [74], [75], [76], [77], [78], [79], [80], [81], 
    [82], [83], [84], [85], [86], [87], [88], [89], [90], [91], [92], [93], [94], [95], [96], [97], 
    [98], [99], [100], [101], [102], [103], [104], [105], [106], [107], [108], [109], [110], [111], 
    [112, 388], [113], [114], [115], [116], [117], [118], [119], [120], [121], [122], [123], [124], [125], 
    [126], [127], [128], [129], [130], [131], [132], [133], [134], [135], [136], [137], [138, 239], [139], 
    [140], [141], [142], [143], [144], [145], [146], [147], [148], [149], [150], [151], [152], [153], 
    [154], [155], [156], [157], [158], [159], [160], [161], [162, 389], [163], [164], [165], [166], [167], 
    [168], [169], [170], [171], [172], [173], [174], [175, 390], [176], [177], [178], [179], [180], [181], 
    [182], [183], [184], [185], [186], [187], [188], [189], [190], [191], [192], [193], [194], [195], 
    [196], [197], [198], [199], [200], [201], [202], [203], [204], [205], [206], [207], [208], [209], 
    [210], [211], [212], [213], [214], [215], [216], [217], [218], [219], [220], [221], [222], [223], 
    [224], [225, 391], [226], [227], [228], [229], [230], [231], [232], [233], [234], [235], [236], [237], 
    [238], [239], [240], [241], [242], [243], [244], [245], [246], [247], [248], [249], [250], [251], 
    [252], [253], [254], [255], [256], [257], [258], [259], [260], [261], [262], [263], [264, 392], [265], 
    [266], [267], [268], [269], [270], [271], [272], [273, 393], [274], [275], [276], [277], [278], [279], 
    [280], [281], [282], [283], [284], [285], [286], [287], [288], [289], [290], [291], [292], [293], 
    [294], [295], [296], [297], [298], [299], [300], [301], [302, 394], [303], [304], [305], [306], [307, 395], 
    [308], [309], [310], [311], [312], [313], [314], [315], [316], [317], [318], [319], [320], [321], 
    [322], [323], [324], [325], [326], [327], [328], [329], [330], [331], [332], [333], [334], [335], 
    [336], [337], [338], [339], [340], [341], [342], [343], [344], [345], [346], [347], [348], [349], 
    [350], [351], [352], [353], [354], [355], [356], [357], [358, 396, 397], [359, 398, 399], [360], [361, 401, 402], [362, 403, 404], [363], 
    [364, 405, 406], [365], [366, 407, 408], [367, 409], [368], [369, 410, 411], [370], [371, 412], [372], [373], [374], [375, 413], [376], [377], 
    [378, 414, 415], [379, 416, 417], [380, 418, 419], [381, 400], [382, 420], [383, 421], [384], [385], [386],
];

export const REGION_INDEX_TO_AREA_CODE_INDICES_2 = [
    [0, 151], // 201/551
    [1, 251], // 202/771
    [2, 124], // 203/475
    [3, 201], // 205/659
    [4, 157], // 206/564
    [5], // 207
    [6, 354], // 208/986
    [7, 79], // 209
    [8, 232], // 210/726
    [9, 70, 196, 318], // 212/332/646/917
    [10, 64, 387], // 213/323/738
    [11, 121, 335, 346], // 214/469/945/972
    [12, 36, 115], // 215/267/445
    [13], // 216
    [14, 116], // 217/447
    [15], // 218
    [16], // 219
    [17, 240], // 220/740
    [18, 226], // 223/717
    [19, 288], // 224/847
    [20], // 225
    [21, 27, 45], // 227/240/301
    [22, 307], // 228/904
    [23], // 229
    [24], // 231
    [25, 68], // 234/330
    [26], // 239
    [21, 27, 45], // 227/240/301
    [28, 336], // 248/947
    [29], // 251
    [30], // 252
    [31], // 253
    [32], // 254
    [33, 330], // 256/938
    [34], // 260
    [35], // 262
    [36, 12, 115], // 267/215/445
    [37], // 269
    [38, 85], // 270/364
    [39, 159], // 272/570
    [40, 321], // 274/920
    [41], // 276
    [42, 317], // 279/916
    [43, 77, 281, 222], // 281/346/832/713
    [44, 139], // 283/513
    [21, 27, 45], // 227/240/301
    [46], // 302
    [47, 229, 351], // 303/720/983
    [48, 211], // 304/681
    [49, 195, 259], // 305/645/786
    [50], // 307
    [51], // 308
    [52, 297], // 309/861
    [53, 106], // 310/424
    [54, 303], // 312/872
    [55], // 313
    [56, 152], // 314/557
    [57, 210], // 315/680
    [58], // 316
    [59, 119], // 317/463
    [60], // 318
    [61], // 319
    [62], // 320
    [95, 63, 213], // 321
    [10, 64, 387], // 213/323/738
    [65], // 325
    [66, 329], // 326/937
    [67, 287], // 329/845
    [68, 25], // 330/234
    [69, 190], // 331/630
    [9, 70, 196, 318], // 212/332/646/917
    [71], // 334
    [72, 241], // 336/743
    [73], // 337
    [74, 257], // 339/781
    [75], // 340
    [76, 137], // 341/510
    [43, 77, 281, 222], // 281/346/832/713
    [78, 324, 227, 318], // 347/929/718/917
    [7, 79], // 350/209
    [80, 348], // 351/978
    [81], // 352
    [82, 4], // 360/564
    [83], // 361
    [84, 141], // 363/516
    [85, 38], // 364/270
    [86, 219], // 369/707
    [87, 179], // 380/614
    [88, 261], // 385/801
    [89], // 386
    [90], // 401
    [91, 146], // 402/531
    [92, 122, 209, 334], // 404/470/678/943
    [93, 161], // 405/572
    [94], // 406
    [95, 63, 213], // 407/321/689
    [96, 206], // 408/669
    [97], // 409
    [98, 114, 205], // 410/443/667
    [99, 304], // 412/878
    [100], // 413
    [101], // 414
    [102, 188], // 415/628
    [103], // 417
    [104, 158], // 419/567
    [105], // 423
    [106, 53], // 424/310
    [107], // 425
    [108, 306], // 430/903
    [109], // 432
    [110], // 434
    [111], // 435
    [112, 388], // 440/436
    [113, 245], // 442/760
    [114, 98, 205], // 443/410/667
    [115, 12, 36], // 445/215/267
    [116, 14], // 447/217
    [117, 290], // 448/850
    [118, 150], // 458/541
    [59, 119], // 317/463
    [120, 220], // 464/708
    [121, 11, 346, 335], // 469/214/972/945
    [92, 122, 209, 334], // 404/470/678/943
    [123, 312], // 472/910
    [124, 2], // 475/203
    [125], // 478
    [126], // 479
    [127, 170, 186], // 480/602/623
    [128, 177, 282], // 484/610/835
    [129], // 501
    [130], // 502
    [131, 345], // 503/971
    [132], // 504
    [133], // 505
    [134], // 507
    [135, 254], // 508/774
    [136], // 509
    [137, 76], // 510/341
    [138, 239], // 512/737
    [44, 139], // 283/513
    [140], // 515
    [84, 141], // 363/516
    [142], // 517
    [143, 283], // 518/838
    [144], // 520
    [145], // 530
    [146, 91], // 531/402
    [147, 224], // 534/715
    [148, 319], // 539/918
    [149, 277], // 540/826
    [150, 118], // 541/458
    [151, 0], // 551/201
    [152, 56], // 557/314
    [153], // 559
    [154, 234], // 561/718
    [155], // 562
    [156], // 563
    [157, 82], // 564/360
    [158, 104], // 567/419
    [159, 39], // 570/272
    [160, 216], // 571/703
    [161, 93], // 572/405
    [162, 389], // 573/235
    [163], // 574
    [164], // 575
    [165], // 580
    [166, 271], // 582/814
    [167], // 585
    [168], // 586
    [169, 249], // 601/769
    [127, 170, 186], // 480/602/623
    [171], // 603
    [172], // 605
    [173], // 606
    [174], // 607
    [175, 390], // 608/353
    [176, 193], // 609/640
    [128, 177, 282], // 484/610/835
    [178], // 612
    [179, 87], // 614/380
    [180, 189], // 615/629
    [181], // 616
    [182, 293], // 617/857
    [183, 235], // 618/730
    [184, 294], // 619/858
    [185], // 620
    [127, 170, 186], // 480/602/623
    [187], // 626
    [188, 102], // 628/415
    [189, 180], // 629/615
    [190, 69], // 630/331
    [191, 327], // 631/934
    [192], // 636
    [193, 176], // 640/609
    [194], // 641
    [195, 49, 259], // 645/305/786
    [9, 70, 196, 318], // 212/332/646/917
    [197], // 650
    [198], // 651
    [199, 270], // 656/813
    [200, 223], // 657/714
    [201, 3], // 659/205
    [202], // 660
    [203], // 661
    [204], // 662
    [205, 98, 114], // 667/410/443
    [206, 96], // 669/408
    [207], // 670
    [208], // 671
    [92, 122, 209, 334], // 404/470/678/943
    [210, 57], // 680/315
    [211, 48], // 681/304
    [212, 274], // 682/817
    [213, 63, 95], // 689/321/407
    [214], // 701
    [215, 231], // 702/725
    [216, 160], // 703/571
    [217, 350], // 704/980
    [218, 246], // 706/762
    [86, 219], // 369/707
    [220, 120], // 708/464
    [221], // 712
    [222, 43, 77, 281], // 713/281/346/832
    [223, 200], // 714/657
    [224, 147], // 715/534
    [225, 391], // 716/624
    [226, 18], // 717/223
    [78, 324, 227, 318], // 347/929/718/917
    [228], // 719
    [229, 47, 351], // 720/303/983
    [230, 304], // 724/878
    [231, 215], // 725/702
    [232, 8], // 726/210
    [233], // 727
    [154, 234], // 561/718
    [183, 235], // 618/730
    [236], // 731
    [237, 289], // 732/848
    [238], // 734
    [239, 138], // 737/512
    [240, 17], // 740/220
    [241, 72], // 743/336
    [242, 275], // 747/818
    [243, 341], // 754/954
    [244, 337], // 757/948
    [245, 113], // 760/442
    [218, 246], // 706/762
    [247], // 763
    [248], // 765
    [249, 169], // 769/601
    [250, 334, 122, 209], // 770/943/470/678
    [251, 1], // 771/202
    [252], // 772
    [253, 303], // 773/872
    [254, 135], // 774/508
    [255], // 775
    [256, 272], // 779/815
    [257, 74], // 781/339
    [258], // 785
    [259, 49, 195], // 786/305/645
    [260, 331], // 787/939
    [261, 88], // 801/385
    [262], // 802
    [263, 284], // 803/839
    [264, 392], // 804/686
    [265, 276], // 805/820
    [266], // 806
    [267], // 808
    [268], // 810
    [269, 325], // 812/930
    [199, 270], // 656/813
    [271, 166], // 814/582
    [256, 272], // 779/815
    [273, 393], // 816/975
    [274, 212], // 817/682
    [275, 242], // 818/747
    [276, 265], // 820/805
    [149, 277], // 540/826
    [278], // 828
    [279], // 830
    [280], // 831
    [43, 77, 281, 222], // 281/346/832/713
    [128, 177, 282], // 484/610/835
    [143, 283], // 518/838
    [284, 263], // 839/803
    [285, 311], // 840/909
    [286, 291], // 843/854
    [67, 287], // 329/845
    [288, 19], // 847/224
    [289, 237], // 848/732
    [290, 117], // 850/448
    [286, 291], // 843/854
    [292], // 856
    [293, 182], // 857/617
    [294, 184], // 858/619
    [295], // 859
    [296, 343], // 860/959
    [52, 297], // 309/861
    [298, 347], // 862/973
    [299], // 863
    [300], // 864
    [301], // 865
    [302, 394], // 870/327
    [303, 54, 253], // 872/312/773
    [304, 99, 230], // 878/412/724
    [305], // 901
    [306, 108], // 903/430
    [307, 395], // 904/324
    [308], // 906
    [309], // 907
    [310], // 908
    [311, 285], // 909/840
    [123, 312], // 472/910
    [313], // 912
    [314], // 913
    [315], // 914
    [316], // 915
    [317, 42], // 916/279
    [318, 9, 70, 196, 78, 324, 227], // 917/212/332/646/347/929/718
    [319, 148], // 918/539
    [320, 352], // 919/984
    [40, 321], // 274/920
    [322], // 925
    [323], // 928
    [78, 324, 227, 318], // 347/929/718/917
    [325, 269], // 930/812
    [326], // 931
    [327, 191], // 934/631
    [328], // 936
    [329, 66], // 937/326
    [330, 33], // 938/256
    [331, 260], // 939/787
    [332], // 940
    [333], // 941
    [92, 122, 209, 334, 250], // 404/470/678/943/770
    [335, 11, 121, 346], // 945/214/469/972
    [336, 28], // 947/248
    [244, 337], // 757/948
    [338], // 949
    [339], // 951
    [340], // 952
    [341, 243], // 954/754
    [342], // 956
    [343, 296], // 959/860
    [344], // 970
    [345, 131], // 971/503
    [346, 11, 121, 335], // 972/214/469/945
    [347, 298], // 973/862
    [348, 80], // 978/351
    [349], // 979
    [350, 217], // 980/704
    [351, 47, 229], // 983/303/720
    [352, 320], // 984/919
    [353], // 985
    [354, 6], // 986/208
    [355], // 989
    [356], // 867
    [], // 671
    [358, 396, 397, 363, 376], // 778/236/672/250/604
    [359, 398, 399, 377, 374], // 587/825/368/403/780
    [360, 381, 400], // 581/418/367
    [361, 401, 402], // 705/249/683
    [362, 373, 403, 404], // 519/226/548/382
    [358, 396, 397, 363], // 778/236/672/250
    [364, 405, 406], // 204/431/584
    [365], // 807
    [366, 407, 408], // 450/579/354
    [367, 368, 409], // 514/438/263
    [367, 368, 409], // 514/438/263
    [369, 384, 410, 411], // 289/905/365/742
    [370], // 867
    [371, 372, 412], // 416/647/437
    [371, 372, 412], // 416/647/437
    [362, 373, 403, 404], // 519/226/548/382
    [359, 398, 399, 374], // 587/825/368/780
    [375, 413], // 902/782
    [358, 396, 397, 376], // 778/236/672/604
    [359, 398, 399, 377], // 587/825/368/403
    [378, 414, 415], // 306/639/474
    [379, 416, 417], // 613/343/753
    [380, 418, 419], // 819/873/468
    [360, 381, 400], // 581/418/367
    [382, 420], // 709/879
    [383, 421], // 506/428
    [369, 384, 410, 411], // 289/905/365/742
    [385], // 684
    []  // 670
];

export const AREA_CODE_INDEX_TO_REGION_INDICES = [
    [0, 151], // 201/551
    [1, 251], // 202/771
    [2, 124], // 203/475
    [3, 201], // 205/659
    [4, 157], // 206/564
    [5], // 207
    [6, 354], // 208/986
    [7, 79], // 209
    [8, 232], // 210/726
    [9, 70, 196, 318], // 212/332/646/917
    [10, 64, 387], // 213/323/738
    [11, 121, 335, 346], // 214/469/945/972
    [12, 36, 115], // 215/267/445
    [13], // 216
    [14, 116], // 217/447
    [15], // 218
    [16], // 219
    [17, 240], // 220/740
    [18, 226], // 223/717
    [19, 288], // 224/847
    [20], // 225
    [21, 27, 45], // 227/240/301
    [22, 307], // 228/904
    [23], // 229
    [24], // 231
    [25, 68], // 234/330
    [26], // 239
    [21, 27, 45], // 227/240/301
    [28, 336], // 248/947
    [29], // 251
    [30], // 252
    [31], // 253
    [32], // 254
    [33, 330], // 256/938
    [34], // 260
    [35], // 262
    [36, 12, 115], // 267/215/445
    [37], // 269
    [38, 85], // 270/364
    [39, 159], // 272/570
    [40, 321], // 274/920
    [41], // 276
    [42, 317], // 279/916
    [43, 77, 281, 222], // 281/346/832/713
    [44, 139], // 283/513
    [21, 27, 45], // 227/240/301
    [46], // 302
    [47, 229, 351], // 303/720/983
    [48, 211], // 304/681
    [49, 195, 259], // 305/645/786
    [50], // 307
    [51], // 308
    [52, 297], // 309/861
    [53, 106], // 310/424
    [54, 303], // 312/872
    [55], // 313
    [56, 152], // 314/557
    [57, 210], // 315/680
    [58], // 316
    [59, 119], // 317/463
    [60], // 318
    [61], // 319
    [62], // 320
    [95, 63, 213], // 407/321/689
    [10, 64, 387], // 213/323/738
    [65], // 325
    [66, 329], // 326/937
    [67, 287], // 329/845
    [68, 25], // 330/234
    [69, 190], // 331/630
    [9, 70, 196, 318], // 212/332/646/917
    [71], // 334
    [72, 241], // 336/743
    [73], // 337
    [74, 257], // 339/781
    [75], // 340
    [76, 137], // 341/510
    [43, 77, 281, 222], // 281/346/832/713
    [78, 324, 227, 318], // 347/929/718/917
    [7, 79], // 350/209
    [80, 348], // 351/978
    [81], // 352
    [82, 4], // 360/564
    [83], // 361
    [84, 141], // 363/516
    [85, 38], // 364/270
    [86, 219], // 369/707
    [87, 179], // 380/614
    [88, 261], // 385/801
    [89], // 386
    [90], // 401
    [91, 146], // 402/531
    [92, 122, 209, 334], // 404/470/678/943
    [93, 161], // 405/572
    [94], // 406
    [95, 63, 213], // 407/321/689
    [96, 206], // 408/669
    [97], // 409
    [98, 114, 205], // 410/443/667
    [99, 304], // 412/878
    [100], // 413
    [101], // 414
    [102, 188], // 415/628
    [103], // 417
    [104, 158], // 419/567
    [105], // 423
    [106, 53], // 424/310
    [107], // 425
    [108, 306], // 430/903
    [109], // 432
    [110], // 434
    [111], // 435
    [112, 388], // 440/436
    [113, 245], // 442/760
    [114, 98, 205], // 443/410/667
    [115, 12, 36], // 445/215/267
    [116, 14], // 447/217
    [117, 290], // 448/850
    [118, 150], // 458/541
    [59, 119], // 317/463
    [120, 220], // 464/708
    [121, 11, 346, 335], // 469/214/972/945
    [92, 122, 209, 334], // 404/470/678/943
    [123, 312], // 472/910
    [124, 2], // 475/203
    [125], // 478
    [126], // 479
    [127, 170, 186], // 480/602/623
    [128, 177, 282], // 484/610/835
    [129], // 501
    [130], // 502
    [131, 345], // 503/971
    [132], // 504
    [133], // 505
    [134], // 507
    [135, 254], // 508/774
    [136], // 509
    [137, 76], // 510/341
    [138, 239], // 512/737
    [44, 139], // 283/513
    [140], // 515
    [84, 141], // 363/516
    [142], // 517
    [143, 283], // 518/838
    [144], // 520
    [145], // 530
    [146, 91], // 531/402
    [147, 224], // 534/715
    [148, 319], // 539/918
    [149, 277], // 540/826
    [150, 118], // 541/458
    [151, 0], // 551/201
    [152, 56], // 557/314
    [153], // 559
    [154, 234], // 561/718
    [155], // 562
    [156], // 563
    [157, 82], // 564/360
    [158, 104], // 567/419
    [159, 39], // 570/272
    [160, 216], // 571/703
    [161, 93], // 572/405
    [162, 389], // 573/235
    [163], // 574
    [164], // 575
    [165], // 580
    [166, 271], // 582/814
    [167], // 585
    [168], // 586
    [169, 249], // 601/769
    [127, 170, 186], // 480/602/623
    [171], // 603
    [172], // 605
    [173], // 606
    [174], // 607
    [175, 390], // 608/353
    [176, 193], // 609/640
    [128, 177, 282], // 484/610/835
    [178], // 612
    [179, 87], // 614/380
    [180, 189], // 615/629
    [181], // 616
    [182, 293], // 617/857
    [183, 235], // 618/730
    [184, 294], // 619/858
    [185], // 620
    [127, 170, 186], // 480/602/623
    [187], // 626
    [188, 102], // 628/415
    [189, 180], // 629/615
    [190, 69], // 630/331
    [191, 327], // 631/934
    [192], // 636
    [193, 176], // 640/609
    [194], // 641
    [195, 49, 259], // 645/305/786
    [9, 70, 196, 318], // 212/332/646/917
    [197], // 650
    [198], // 651
    [199, 270], // 656/813
    [200, 223], // 657/714
    [201, 3], // 659/205
    [202], // 660
    [203], // 661
    [204], // 662
    [205, 98, 114], // 667/410/443
    [206, 96], // 669/408
    [207], // 670
    [208], // 671
    [92, 122, 209, 334], // 404/470/678/943
    [210, 57], // 680/315
    [211, 48], // 681/304
    [212, 274], // 682/817
    [213, 63, 95], // 689/321/407
    [214], // 701
    [215, 231], // 702/725
    [216, 160], // 703/571
    [217, 350], // 704/980
    [218, 246], // 706/762
    [86, 219], // 369/707
    [220, 120], // 708/464
    [221], // 712
    [222, 43, 77, 281], // 713/281/346/832
    [223, 200], // 714/657
    [224, 147], // 715/534
    [225, 391], // 716/624
    [226, 18], // 717/223
    [78, 324, 227, 318], // 347/929/718/917
    [228], // 719
    [229, 47, 351], // 720/303/983
    [230, 304], // 724/878
    [231, 215], // 725/702
    [232, 8], // 726/210
    [233], // 727
    [154, 234], // 561/718
    [183, 235], // 618/730
    [236], // 731
    [237, 289], // 732/848
    [238], // 734
    [239, 138], // 737/512
    [240, 17], // 740/220
    [241, 72], // 743/336
    [242, 275], // 747/818
    [243, 341], // 754/954
    [244, 337], // 757/948
    [245, 113], // 760/442
    [218, 246], // 706/762
    [247], // 763
    [248], // 765
    [249, 169], // 769/601
    [250, 334, 122, 209], // 770/943/470/678
    [251, 1], // 771/202
    [252], // 772
    [253, 303], // 773/872
    [254, 135], // 774/508
    [255], // 775
    [256, 272], // 779/815
    [257, 74], // 781/339
    [258], // 785
    [259, 49, 195], // 786/305/645
    [260, 331], // 787/939
    [261, 88], // 801/385
    [262], // 802
    [263, 284], // 803/839
    [264, 392], // 804/686
    [265, 276], // 805/820
    [266], // 806
    [267], // 808
    [268], // 810
    [269, 325], // 812/930
    [199, 270], // 656/813
    [271, 166], // 814/582
    [256, 272], // 779/815
    [273, 393], // 816/975
    [274, 212], // 817/682
    [275, 242], // 818/747
    [276, 265], // 820/805
    [149, 277], // 540/826
    [278], // 828
    [279], // 830
    [280], // 831
    [43, 77, 281, 222], // 281/346/832/713
    [128, 177, 282], // 484/610/835
    [143, 283], // 518/838
    [284, 263], // 839/803
    [285, 311], // 840/909
    [286, 291], // 843/854
    [67, 287], // 329/845
    [288, 19], // 847/224
    [289, 237], // 848/732
    [290, 117], // 850/448
    [286, 291], // 843/854
    [292], // 856
    [293, 182], // 857/617
    [294, 184], // 858/619
    [295], // 859
    [296, 343], // 860/959
    [52, 297], // 309/861
    [298, 347], // 862/973
    [299], // 863
    [300], // 864
    [301], // 865
    [302, 394], // 870/327
    [303, 54, 253], // 872/312/773
    [304, 99, 230], // 878/412/724
    [305], // 901
    [306, 108], // 903/430
    [307, 395], // 904/324
    [308], // 906
    [309], // 907
    [310], // 908
    [311, 285], // 909/840
    [123, 312], // 472/910
    [313], // 912
    [314], // 913
    [315], // 914
    [316], // 915
    [317, 42], // 916/279
    [318, 9, 70, 196, 78, 324, 227], // 917/212/332/646/347/929/718
    [319, 148], // 918/539
    [320, 352], // 919/984
    [40, 321], // 274/920
    [322], // 925
    [323], // 928
    [78, 324, 227, 318], // 347/929/718/917
    [325, 269], // 930/812
    [326], // 931
    [327, 191], // 934/631
    [328], // 936
    [329, 66], // 937/326
    [330, 33], // 938/256
    [331, 260], // 939/787
    [332], // 940
    [333], // 941
    [92, 122, 209, 334, 250], // 404/470/678/943/770
    [335, 11, 121, 346], // 945/214/469/972
    [336, 28], // 947/248
    [244, 337], // 757/948
    [338], // 949
    [339], // 951
    [340], // 952
    [341, 243], // 954/754
    [342], // 956
    [343, 296], // 959/860
    [344], // 970
    [345, 131], // 971/503
    [346, 11, 121, 335], // 972/214/469/945
    [347, 298], // 973/862
    [348, 80], // 978/351
    [349], // 979
    [350, 217], // 980/704
    [351, 47, 229], // 983/303/720
    [352, 320], // 984/919
    [353], // 985
    [354, 6], // 986/208
    [355], // 989
    [356], // 867
    [357], // 671
    [358, 396, 397, 363, 376], // 778/236/672/250/604
    [359, 398, 399, 377, 374], // 587/825/368/403/780
    [360, 381, 400], // 581/418/367
    [361, 401, 402], // 705/249/683
    [362, 373, 403, 404], // 519/226/548/382
    [358, 396, 397, 363], // 778/236/672/250
    [364, 405, 406], // 204/431/584
    [365], // 807
    [366, 407, 408], // 450/579/354
    [367, 368, 409], // 514/438/263
    [367, 368, 409], // 514/438/263
    [369, 384, 410, 411], // 289/905/365/742
    [370], // 867
    [371, 372, 412], // 416/647/437
    [371, 372, 412], // 416/647/437
    [362, 373, 403, 404], // 519/226/548/382
    [359, 398, 399, 374], // 587/825/368/780
    [375, 413], // 902/782
    [358, 396, 397, 376], // 778/236/672/604
    [359, 398, 399, 377], // 587/825/368/403
    [378, 414, 415], // 306/639/474
    [379, 416, 417], // 613/343/753
    [380, 418, 419], // 819/873/468
    [360, 381, 400], // 581/418/367
    [382, 420], // 709/879
    [383, 421], // 506/428
    [369, 384, 410, 411], // 289/905/365/742
    [385], // 684
    [386],  // 670
    [10, 64, 387], // 213/323/738
    [112, 388], // 440/436
    [162, 389], // 573/235
    [175, 390], // 608/353
    [225, 391], // 716/624
    [264, 392], // 804/686
    [273, 393], // 816/975
    [302, 394], // 870/327
    [307, 395], // 904/324
    [358, 396, 397, 363, 376], // 778/236/672/250/604
    [358, 396, 397, 363, 376], // 778/236/672/250/604
    [359, 398, 399, 377, 374], // 587/825/368/403/780
    [359, 398, 399, 377, 374], // 587/825/368/403/780
    [360, 381, 400], // 581/418/367
    [361, 401, 402], // 705/249/683
    [361, 401, 402], // 705/249/683
    [362, 373, 403, 404], // 519/226/548/382
    [362, 373, 403, 404], // 519/226/548/382
    [364, 405, 406], // 204/431/584
    [364, 405, 406], // 204/431/584
    [366, 407, 408], // 450/579/354
    [366, 407, 408], // 450/579/354
    [367, 368, 409], // 514/438/263
    [369, 384, 410, 411], // 289/905/365/742
    [369, 384, 410, 411], // 289/905/365/742
    [371, 372, 412], // 416/647/437
    [375, 413], // 902/782
    [378, 414, 415], // 306/639/474
    [378, 414, 415], // 306/639/474
    [379, 416, 417], // 613/343/753
    [379, 416, 417], // 613/343/753
    [380, 418, 419], // 819/873/468
    [380, 418, 419], // 819/873/468
    [382, 420], // 709/879
];

export const REGION_INDEX_TO_REGION_BITFLAG = [
    0x01, // 0: 201 (NJ) - Northeast
    0x01, // 1: 202 (DC) - Northeast
    0x01, // 2: 203 (CT) - Northeast
    0x02, // 3: 205 (AL) - South
    0x08, // 4: 206 (WA) - West
    0x01, // 5: 207 (ME) - Northeast
    0x08, // 6: 208 (ID) - West
    0x08, // 7: 209 (CA) - West
    0x04, // 8: 210 (TX) - Southwest
    0x01, // 9: 212 (NY) - Northeast
    0x08, // 10: 213 (CA) - West
    0x04, // 11: 214 (TX) - Southwest
    0x01, // 12: 215 (PA) - Northeast
    0x10, // 13: 216 (OH) - Midwest
    0x10, // 14: 217 (IL) - Midwest
    0x10, // 15: 218 (MN) - Midwest
    0x10, // 16: 219 (IN) - Midwest
    0x10, // 17: 220 (OH) - Midwest
    0x01, // 18: 223 (PA) - Northeast
    0x10, // 19: 224 (IL) - Midwest
    0x02, // 20: 225 (LA) - South
    0x01, // 21: 227 (MD) - Northeast
    0x02, // 22: 228 (MS) - South
    0x02, // 23: 229 (GA) - South
    0x10, // 24: 231 (MI) - Midwest
    0x10, // 25: 234 (OH) - Midwest
    0x02, // 26: 239 (FL) - South
    0x01, // 27: 240 (MD) - Northeast
    0x10, // 28: 248 (MI) - Midwest
    0x02, // 29: 251 (AL) - South
    0x02, // 30: 252 (NC) - South
    0x08, // 31: 253 (WA) - West
    0x04, // 32: 254 (TX) - Southwest
    0x02, // 33: 256 (AL) - South
    0x10, // 34: 260 (IN) - Midwest
    0x10, // 35: 262 (WI) - Midwest
    0x01, // 36: 267 (PA) - Northeast
    0x10, // 37: 269 (MI) - Midwest
    0x02, // 38: 270 (KY) - South
    0x01, // 39: 272 (PA) - Northeast
    0x10, // 40: 274 (IN) - Midwest
    0x02, // 41: 276 (VA) - South
    0x08, // 42: 279 (CA) - West
    0x04, // 43: 281 (TX) - Southwest
    0x10, // 44: 283 (OH) - Midwest
    0x01, // 45: 301 (MD) - Northeast
    0x01, // 46: 302 (DE) - Northeast
    0x08, // 47: 303 (CO) - West
    0x02, // 48: 304 (WV) - South
    0x02, // 49: 305 (FL) - South
    0x08, // 50: 307 (WY) - West
    0x10, // 51: 308 (NE) - Midwest
    0x10, // 52: 309 (IL) - Midwest
    0x08, // 53: 310 (CA) - West
    0x10, // 54: 312 (IL) - Midwest
    0x10, // 55: 313 (MI) - Midwest
    0x10, // 56: 314 (MO) - Midwest
    0x01, // 57: 315 (NY) - Northeast
    0x10, // 58: 316 (KS) - Midwest
    0x10, // 59: 317 (IN) - Midwest
    0x02, // 60: 318 (LA) - South
    0x10, // 61: 319 (IA) - Midwest
    0x10, // 62: 320 (MN) - Midwest
    0x02, // 63: 321 (FL) - South
    0x08, // 64: 323 (CA) - West
    0x04, // 65: 325 (TX) - Southwest
    0x10, // 66: 326 (OH) - Midwest
    0x01, // 67: 329 (NY) - Northeast
    0x10, // 68: 330 (OH) - Midwest
    0x10, // 69: 331 (IL) - Midwest
    0x01, // 70: 332 (NY) - Northeast
    0x02, // 71: 334 (AL) - South
    0x02, // 72: 336 (NC) - South
    0x02, // 73: 337 (LA) - South
    0x01, // 74: 339 (MA) - Northeast
    0x40, // 75: 340 (VI) - US Territory
    0x08, // 76: 341 (CA) - West
    0x04, // 77: 346 (TX) - Southwest
    0x01, // 78: 347 (NY) - Northeast
    0x08, // 79: 350 (CA) - West
    0x01, // 80: 351 (MA) - Northeast
    0x02, // 81: 352 (FL) - South
    0x08, // 82: 360 (WA) - West
    0x04, // 83: 361 (TX) - Southwest
    0x01, // 84: 363 (NY) - Northeast
    0x02, // 85: 364 (KY) - South
    0x08, // 86: 369 (CA) - West
    0x10, // 87: 380 (OH) - Midwest
    0x08, // 88: 385 (UT) - West
    0x02, // 89: 386 (FL) - South
    0x01, // 90: 401 (RI) - Northeast
    0x10, // 91: 402 (NE) - Midwest
    0x02, // 92: 404 (GA) - South
    0x04, // 93: 405 (OK) - Southwest
    0x08, // 94: 406 (MT) - West
    0x02, // 95: 407 (FL) - South
    0x08, // 96: 408 (CA) - West
    0x04, // 97: 409 (TX) - Southwest
    0x01, // 98: 410 (MD) - Northeast
    0x01, // 99: 412 (PA) - Northeast
    0x01, // 100: 413 (MA) - Northeast
    0x10, // 101: 414 (WI) - Midwest
    0x08, // 102: 415 (CA) - West
    0x10, // 103: 417 (MO) - Midwest
    0x10, // 104: 419 (OH) - Midwest
    0x02, // 105: 423 (TN) - South
    0x08, // 106: 424 (CA) - West
    0x08, // 107: 425 (WA) - West
    0x04, // 108: 430 (TX) - Southwest
    0x04, // 109: 432 (TX) - Southwest
    0x02, // 110: 434 (VA) - South
    0x08, // 111: 435 (UT) - West
    0x10, // 112: 440 (OH) - Midwest
    0x08, // 113: 442 (CA) - West
    0x01, // 114: 443 (MD) - Northeast
    0x01, // 115: 445 (PA) - Northeast
    0x10, // 116: 447 (IL) - Midwest
    0x02, // 117: 448 (GA) - South
    0x08, // 118: 458 (OR) - West
    0x10, // 119: 463 (IN) - Midwest
    0x10, // 120: 464 (IL) - Midwest
    0x04, // 121: 469 (TX) - Southwest
    0x02, // 122: 470 (GA) - South
    0x02, // 123: 472 (GA) - South
    0x01, // 124: 475 (CT) - Northeast
    0x02, // 125: 478 (GA) - South
    0x02, // 126: 479 (AR) - South
    0x04, // 127: 480 (AZ) - Southwest
    0x01, // 128: 484 (PA) - Northeast
    0x02, // 129: 501 (AR) - South
    0x02, // 130: 502 (KY) - South
    0x08, // 131: 503 (OR) - West
    0x02, // 132: 504 (LA) - South
    0x04, // 133: 505 (NM) - Southwest
    0x10, // 134: 507 (MN) - Midwest
    0x01, // 135: 508 (MA) - Northeast
    0x08, // 136: 509 (WA) - West
    0x08, // 137: 510 (CA) - West
    0x04, // 138: 512 (TX) - Southwest
    0x10, // 139: 513 (OH) - Midwest
    0x10, // 140: 515 (IA) - Midwest
    0x01, // 141: 516 (NY) - Northeast
    0x10, // 142: 517 (MI) - Midwest
    0x01, // 143: 518 (NY) - Northeast
    0x04, // 144: 520 (AZ) - Southwest
    0x08, // 145: 530 (CA) - West
    0x10, // 146: 531 (NE) - Midwest
    0x10, // 147: 534 (WI) - Midwest
    0x04, // 148: 539 (OK) - Southwest
    0x02, // 149: 540 (VA) - South
    0x08, // 150: 541 (OR) - West
    0x01, // 151: 551 (NJ) - Northeast
    0x10, // 152: 557 (MO) - Midwest
    0x08, // 153: 559 (CA) - West
    0x02, // 154: 561 (FL) - South
    0x08, // 155: 562 (CA) - West
    0x10, // 156: 563 (IA) - Midwest
    0x08, // 157: 564 (WA) - West
    0x10, // 158: 567 (OH) - Midwest
    0x01, // 159: 570 (PA) - Northeast
    0x02, // 160: 571 (VA) - South
    0x04, // 161: 572 (OK) - Southwest
    0x10, // 162: 573 (MO) - Midwest
    0x10, // 163: 574 (IN) - Midwest
    0x04, // 164: 575 (NM) - Southwest
    0x04, // 165: 580 (OK) - Southwest
    0x01, // 166: 582 (PA) - Northeast
    0x01, // 167: 585 (NY) - Northeast
    0x10, // 168: 586 (MI) - Midwest
    0x02, // 169: 601 (MS) - South
    0x04, // 170: 602 (AZ) - Southwest
    0x01, // 171: 603 (NH) - Northeast
    0x10, // 172: 605 (SD) - Midwest
    0x02, // 173: 606 (KY) - South
    0x01, // 174: 607 (NY) - Northeast
    0x10, // 175: 608 (WI) - Midwest
    0x01, // 176: 609 (NJ) - Northeast
    0x01, // 177: 610 (PA) - Northeast
    0x10, // 178: 612 (MN) - Midwest
    0x10, // 179: 614 (OH) - Midwest
    0x02, // 180: 615 (TN) - South
    0x10, // 181: 616 (MI) - Midwest
    0x01, // 182: 617 (MA) - Northeast
    0x10, // 183: 618 (IL) - Midwest
    0x08, // 184: 619 (CA) - West
    0x10, // 185: 620 (KS) - Midwest
    0x04, // 186: 623 (AZ) - Southwest
    0x08, // 187: 626 (CA) - West
    0x08, // 188: 628 (CA) - West
    0x02, // 189: 629 (TN) - South
    0x10, // 190: 630 (IL) - Midwest
    0x01, // 191: 631 (NY) - Northeast
    0x10, // 192: 636 (MO) - Midwest
    0x01, // 193: 640 (NJ) - Northeast
    0x10, // 194: 641 (IA) - Midwest
    0x02, // 195: 645 (FL) - South
    0x01, // 196: 646 (NY) - Northeast
    0x08, // 197: 650 (CA) - West
    0x10, // 198: 651 (MN) - Midwest
    0x02, // 199: 656 (FL) - South
    0x08, // 200: 657 (CA) - West
    0x02, // 201: 659 (AL) - South
    0x10, // 202: 660 (MO) - Midwest
    0x08, // 203: 661 (CA) - West
    0x02, // 204: 662 (MS) - South
    0x01, // 205: 667 (MD) - Northeast
    0x08, // 206: 669 (CA) - West
    0x40, // 207: 670 (MP) - US Territory
    0x40, // 208: 671 (GU) - US Territory
    0x02, // 209: 678 (GA) - South
    0x01, // 210: 680 (NY) - Northeast
    0x02, // 211: 681 (WV) - South
    0x04, // 212: 682 (TX) - Southwest
    0x02, // 213: 689 (FL) - South
    0x10, // 214: 701 (ND) - Midwest
    0x08, // 215: 702 (NV) - West
    0x02, // 216: 703 (VA) - South
    0x02, // 217: 704 (NC) - South
    0x02, // 218: 706 (GA) - South
    0x08, // 219: 707 (CA) - West
    0x10, // 220: 708 (IL) - Midwest
    0x10, // 221: 712 (IA) - Midwest
    0x04, // 222: 713 (TX) - Southwest
    0x08, // 223: 714 (CA) - West
    0x10, // 224: 715 (WI) - Midwest
    0x01, // 225: 716 (NY) - Northeast
    0x01, // 226: 717 (PA) - Northeast
    0x01, // 227: 718 (NY) - Northeast
    0x08, // 228: 719 (CO) - West
    0x08, // 229: 720 (CO) - West
    0x01, // 230: 724 (PA) - Northeast
    0x08, // 231: 725 (NV) - West
    0x04, // 232: 726 (TX) - Southwest
    0x02, // 233: 727 (FL) - South
    0x02, // 234: 728 (FL) - South
    0x10, // 235: 730 (IL) - Midwest
    0x02, // 236: 731 (TN) - South
    0x01, // 237: 732 (NJ) - Northeast
    0x10, // 238: 734 (MI) - Midwest
    0x04, // 239: 737 (TX) - Southwest
    0x10, // 240: 740 (OH) - Midwest
    0x02, // 241: 743 (NC) - South
    0x08, // 242: 747 (CA) - West
    0x02, // 243: 754 (FL) - South
    0x02, // 244: 757 (VA) - South
    0x08, // 245: 760 (CA) - West
    0x02, // 246: 762 (GA) - South
    0x10, // 247: 763 (MN) - Midwest
    0x10, // 248: 765 (IN) - Midwest
    0x02, // 249: 769 (MS) - South
    0x02, // 250: 770 (GA) - South
    0x01, // 251: 771 (DC) - Northeast
    0x02, // 252: 772 (FL) - South
    0x10, // 253: 773 (IL) - Midwest
    0x01, // 254: 774 (MA) - Northeast
    0x08, // 255: 775 (NV) - West
    0x10, // 256: 779 (IL) - Midwest
    0x01, // 257: 781 (MA) - Northeast
    0x10, // 258: 785 (KS) - Midwest
    0x02, // 259: 786 (FL) - South
    0x40, // 260: 787 (PR) - US Territory
    0x08, // 261: 801 (UT) - West
    0x01, // 262: 802 (VT) - Northeast
    0x02, // 263: 803 (SC) - South
    0x02, // 264: 804 (VA) - South
    0x08, // 265: 805 (CA) - West
    0x04, // 266: 806 (TX) - Southwest
    0x08, // 267: 808 (HI) - West
    0x10, // 268: 810 (MI) - Midwest
    0x10, // 269: 812 (IN) - Midwest
    0x02, // 270: 813 (FL) - South
    0x01, // 271: 814 (PA) - Northeast
    0x10, // 272: 815 (IL) - Midwest
    0x10, // 273: 816 (MO) - Midwest
    0x04, // 274: 817 (TX) - Southwest
    0x08, // 275: 818 (CA) - West
    0x08, // 276: 820 (CA) - West
    0x02, // 277: 826 (VA) - South
    0x02, // 278: 828 (NC) - South
    0x04, // 279: 830 (TX) - Southwest
    0x08, // 280: 831 (CA) - West
    0x04, // 281: 832 (TX) - Southwest
    0x01, // 282: 835 (PA) - Northeast
    0x01, // 283: 838 (NY) - Northeast
    0x02, // 284: 839 (SC) - South
    0x08, // 285: 840 (CA) - West
    0x02, // 286: 843 (SC) - South
    0x01, // 287: 845 (NY) - Northeast
    0x10, // 288: 847 (IL) - Midwest
    0x01, // 289: 848 (NJ) - Northeast
    0x02, // 290: 850 (FL) - South
    0x02, // 291: 854 (SC) - South
    0x01, // 292: 856 (NJ) - Northeast
    0x01, // 293: 857 (MA) - Northeast
    0x08, // 294: 858 (CA) - West
    0x02, // 295: 859 (KY) - South
    0x01, // 296: 860 (CT) - Northeast
    0x10, // 297: 861 (IL) - Midwest
    0x01, // 298: 862 (NJ) - Northeast
    0x02, // 299: 863 (FL) - South
    0x02, // 300: 864 (SC) - South
    0x02, // 301: 865 (TN) - South
    0x02, // 302: 870 (AR) - South
    0x10, // 303: 872 (IL) - Midwest
    0x01, // 304: 878 (PA) - Northeast
    0x02, // 305: 901 (TN) - South
    0x04, // 306: 903 (TX) - Southwest
    0x02, // 307: 904 (FL) - South
    0x10, // 308: 906 (MI) - Midwest
    0x08, // 309: 907 (AK) - West
    0x01, // 310: 908 (NJ) - Northeast
    0x08, // 311: 909 (CA) - West
    0x02, // 312: 910 (NC) - South
    0x02, // 313: 912 (GA) - South
    0x10, // 314: 913 (KS) - Midwest
    0x01, // 315: 914 (NY) - Northeast
    0x04, // 316: 915 (TX) - Southwest
    0x08, // 317: 916 (CA) - West
    0x01, // 318: 917 (NY) - Northeast
    0x04, // 319: 918 (OK) - Southwest
    0x02, // 320: 919 (NC) - South
    0x10, // 321: 920 (WI) - Midwest
    0x08, // 322: 925 (CA) - West
    0x04, // 323: 928 (AZ) - Southwest
    0x01, // 324: 929 (NY) - Northeast
    0x02, // 325: 930 (TN) - South
    0x02, // 326: 931 (TN) - South
    0x01, // 327: 934 (NY) - Northeast
    0x04, // 328: 936 (TX) - Southwest
    0x10, // 329: 937 (OH) - Midwest
    0x02, // 330: 938 (AL) - South
    0x40, // 331: 939 (PR) - US Territory
    0x04, // 332: 940 (TX) - Southwest
    0x02, // 333: 941 (FL) - South
    0x02, // 334: 943 (GA) - South
    0x04, // 335: 945 (TX) - Southwest
    0x10, // 336: 947 (MI) - Midwest
    0x02, // 337: 948 (VA) - South
    0x08, // 338: 949 (CA) - West
    0x08, // 339: 951 (CA) - West
    0x10, // 340: 952 (MN) - Midwest
    0x02, // 341: 954 (FL) - South
    0x04, // 342: 956 (TX) - Southwest
    0x01, // 343: 959 (CT) - Northeast
    0x08, // 344: 970 (CO) - West
    0x08, // 345: 971 (OR) - West
    0x04, // 346: 972 (TX) - Southwest
    0x01, // 347: 973 (NJ) - Northeast
    0x01, // 348: 978 (MA) - Northeast
    0x04, // 349: 979 (TX) - Southwest
    0x02, // 350: 980 (NC) - South
    0x08, // 351: 983 (CO) - West
    0x02, // 352: 984 (NC) - South
    0x02, // 353: 985 (LA) - South
    0x08, // 354: 986 (ID) - West
    0x10, // 355: 989 (MI) - Midwest
    0x20, // 356: 867 (YT/NT/NU) - Canada
    0x40, // 357: 671 (GU) - US Territory
    0x20, // 358: 778 (BC) - Canada
    0x20, // 359: 587 (AB) - Canada
    0x20, // 360: 581 (QC) - Canada
    0x20, // 361: 705 (ON) - Canada
    0x20, // 362: 519 (ON) - Canada
    0x20, // 363: 250 (BC) - Canada
    0x20, // 364: 204 (MB) - Canada
    0x20, // 365: 807 (ON) - Canada
    0x20, // 366: 450 (QC) - Canada
    0x20, // 367: 514 (QC) - Canada
    0x20, // 368: 438 (QC) - Canada
    0x20, // 369: 289 (ON) - Canada
    0x20, // 370: 867 (YT/NT/NU) - Canada
    0x20, // 371: 416 (ON) - Canada
    0x20, // 372: 647 (ON) - Canada
    0x20, // 373: 226 (ON) - Canada
    0x20, // 374: 780 (AB) - Canada
    0x20, // 375: 902 (NS/PE) - Canada
    0x20, // 376: 604 (BC) - Canada
    0x20, // 377: 403 (AB) - Canada
    0x20, // 378: 306 (SK) - Canada
    0x20, // 379: 613 (ON) - Canada
    0x20, // 380: 819 (QC) - Canada
    0x20, // 381: 418 (QC) - Canada
    0x20, // 382: 709 (NL) - Canada
    0x20, // 383: 506 (NB) - Canada
    0x20, // 384: 905 (ON) - Canada
    0x40, // 385: 684 (AS) - US Territory
    0x40  // 386: 670 (MP) - US Territory
];